import { LocalStorageService } from "@m4u-angular/core/framework/local-storage.service";
import { AppInjector } from "@m4u-angular/core/injector/injector.module";
import PivotGrid, { Properties } from "devextreme/ui/pivot_grid";

export function SetPivotGridDefaults() {
    const localStorageService = AppInjector.get(LocalStorageService);

    PivotGrid.defaultOptions
        ({
            options:
            {
                stateStoring:
                {
                    enabled: true,
                    type: 'custom',
                    savingTimeout: 1000,
                    storageKey: '',

                    customSave(state) {
                        for (const field of state.fields) { 
                            if (field.area === 'filter') {
                                delete field.filterValues;
                            }
                        }
                        localStorageService.SetItem(this.storageKey || 'storage', JSON.stringify(state));
                    },
                    customLoad() {
                        return JSON.parse(localStorageService.GetItem(this.storageKey || 'storage'));
                    }
                },
            }
        });
}